import { CoincidenceAllResponse, IncidentAllResponse } from "app/types/c_nomina";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_NET;

export async function getAllIncidents(page: number | string, pageSize: number | string) {
  try {
    const response = await axios.get<IncidentAllResponse>(`${API_URL}LoadFirstExcel/incidents?page=${page}&pageSize=${pageSize}`);
    return response.data.data;
  } catch (error) {
    if(axios.isAxiosError(error)){
      return {
        page: Number(page),
        pageSize: Number(pageSize),
        totalRecords: 0,
        records: [],
      }; 
    }
    console.error("Error fetching Incidents:", error);
    throw error;
  }
}

export async function getAllCoincidences(page: number | string, pageSize: number | string) {
  try {
    const response = await axios.get<CoincidenceAllResponse>(`${API_URL}LoadFirstExcel?page=${page}&pageSize=${pageSize}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching Coincidences:", error);
    throw error;
  }
}

export async function getProcessSecondRoster(idRoster:number){
  try {
    const response = await axios.get(`${API_URL}LoadFirstExcel/process-second-roster?idPeriodo=${idRoster}`);
    return response.data.data;
  } catch (error) {
    console.error("Error processing the roster");
    throw error
  }
}

